import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import Fragment from "vue-fragment";
import axios from "axios";
import { message } from "./utils/message";
import { Loading } from "element-ui";
import _ from "lodash";
import { dateFormat1, dateFormat2,checkClientArray,checkSelectShow,selectFind,getItemName,getItemId } from "./utils/app";

import "element-ui/lib/theme-chalk/index.css";
import "@/icons";

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
import vPreviewImage,{ setPreviewDefaultOptions } from 'v-preview-image'
Vue.use(vPreviewImage)
// 设置预览默认参数
setPreviewDefaultOptions({
  previewStyle: { maxWidth: '1140px',maxHeight: '650px',objectFit: 'cover'}, // 预览图样式
})

import Directives from "./utils/index";
Vue.use(Directives);
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Loading);
Vue.prototype.axios = axios;
Vue.use(Fragment.Plugin);
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VueVideoPlayer)

import queryBox from '@/components/query-box.vue'
import NavTabBar from '@/components/NavTabBar.vue'
import selectableBlock from '@/components/selectable-block.vue'
import exportBox from '@/components/export-box.vue'
import multipleClientSelect from '@/components/multiple-client-select.vue'
Vue.component('query-box', queryBox)
Vue.component('nav-tab-bar', NavTabBar)+
Vue.component('selectable-block', selectableBlock)
Vue.component('export-box', exportBox)
Vue.component('multiple-client-select', multipleClientSelect)

Vue.prototype.$bus = new Vue();
Vue.prototype.$message = message;
Vue.prototype.$date1 = dateFormat1;
Vue.prototype.$date2 = dateFormat2;
Vue.prototype.$checkClient = checkClientArray;
Vue.prototype.$checkSelect = checkSelectShow;
Vue.prototype.$selectFind = selectFind;
Vue.prototype.$getItemName = getItemName;
Vue.prototype.$getItemId = getItemId;
Vue.prototype.$debounce = function (fn, immediate = true, delay) {
  let timer;
  let delayTime = delay || 3000;
  return function () {
    if (timer) clearTimeout(timer);
    if (immediate) {
      let bool = !timer;
      timer = setTimeout(() => (timer = 0), delayTime);
      return bool && fn.apply(this, [...arguments]);
    }
    timer = setTimeout(() => fn.apply(this, [...arguments]), delayTime);
  };
};
// Vue.prototype.$BASE_knowHouse = "http://192.168.9.47:8787";
// Vue.prototype.$BASE_URL = "http://192.168.9.47/bhoa_v2/public/";
// Vue.prototype.$BASE_OUT_URL = "http://192.168.9.47/bhfw_v2/public/";
// Vue.prototype.$BASE_WY_URL = "http://192.168.9.47/bhwy_v2/public/";
// Vue.prototype.$BASE_EXPORT_URL = 'http://192.168.9.47:7777'


// 判断是否为新年
const newYearDate = new Date('2026-02-13T00:00:00+08:00');
const endDate = new Date('2026-03-03T23:59:59+08:00');
// const newYearDate = new Date('2025-01-20T15:30:00+08:00');
// const endDate = new Date('2025-01-20T16:00:00+08:00');
const currentDate = new Date();
// Vue.prototype.$New_Year = currentDate.getTime() >= newYearDate.getTime() && currentDate.getTime() <= endDate.getTime();
Vue.prototype.$New_Year = false


// Vue.prototype.$BASE_URL = "https://new.testoa.lianghang.cc/";
// Vue.prototype.$BASE_OUT_URL = "https://new.testbhfw.lianghang.cc/";
// Vue.prototype.$BASE_COMMON_URL = "https://new.testbhmh.lianghang.cc/bhmh/#";
// Vue.prototype.$BASE_knowHouse = "https://test.filestash.tjbinhang.cn:37983";
// Vue.prototype.$BASE_qc = "https://new.testbhmh.lianghang.cc/bhmh/#";
// Vue.prototype.$BASE_OA_URL = 'https://new.testoa.lianghang.cc/'
// Vue.prototype.$BASE_WY_URL = 'https://new.testbhwy.lianghang.cc/'
// Vue.prototype.$BASE_EXPORT_URL = 'https://test.basktask.lianghang.cc'

Vue.prototype.$BASE_URL = "https://oa.tjbinhang.cn/";
Vue.prototype.$BASE_OUT_URL = "https://wq.tjbinhang.cn/";
Vue.prototype.$BASE_knowHouse = "https://filestash.tjbinhang.cn:37983"; //正式环境
Vue.prototype.$BASE_qc = "https://one.tjbinhang.cn/#";
Vue.prototype.$BASE_COMMON_URL = "https://one.tjbinhang.cn/#";
Vue.prototype.$BASE_OA_URL = 'https://oa.tjbinhang.cn/'
Vue.prototype.$BASE_WY_URL = 'https://wy.tjbinhang.cn/'
Vue.prototype.$BASE_EXPORT_URL = 'https://basktask.lianghang.cc'




ElementUI.Dialog.props.closeOnClickModal.default = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
